import { ReqRecruitmentItem_SalaryBase } from "./ItemContractorAttendance_RecruitmentItem_SalaryBase"

export class ReqRecruitmentItem_SalaryHourly extends ReqRecruitmentItem_SalaryBase {
    constructor({ Recruitment, caseInfo, PositionInfo, startDate, endDate }) {
        super({ Recruitment, caseInfo, PositionInfo, startDate, endDate })
        if (PositionInfo === undefined)
            return
        this.HourlyWage = 0                                            //時薪 請/付
        this.AttendanceHourItems = []                                          //出勤工時
        this.AttendanceHour = ""                                          //出勤工時
        this.initAttendanceHourItems()
        this.setAttendanceHour()
        this.hourlySalary = PositionInfo.wageInfo.InvoiceHourlyWage1
        this.setDate()
        this.setDailyWageHourly()
        this.PreTax = 0                                                 //請款
        this.Salary = 0                                                 //應付薪資
        this.ExtraPayeHourlyWage = PositionInfo.wageInfo.ExtraPayeHourlyWage                                    //家庭照顧金
        this.PreServiceFee = 0                                          //服務費-未扣保費
        this.setSalary()
    }

    fromJson(jsonData) {
        super.fromJson(jsonData)
        this.HourlyWage = jsonData.HourlyWage                              //時薪 請/付
        this.AttendanceHourItems = jsonData.AttendanceHourItems             //出勤工時
        this.AttendanceHour = jsonData.AttendanceHour                      //出勤工時
        this.ExtraPayeHourlyWage = jsonData.ExtraPayeHourlyWage
        this.setDate()
        // this.setSalary()
    }

    //出勤工時初始化
    initAttendanceHourItems() {
        this.AttendanceHourItems.push(new ReqAttendanceHourItem({ key: 'AttendanceHour1', name: "正常班", hours: 0 }))
        this.AttendanceHourItems.push(new ReqAttendanceHourItem({ key: 'AttendanceHour2', name: "加班", hours: 0 }))
        this.AttendanceHourItems.push(new ReqAttendanceHourItem({ key: 'AttendanceHour3', name: "超時加班", hours: 0 }))
        this.AttendanceHourItems.push(new ReqAttendanceHourItem({ key: 'AttendanceHour4', name: "假日加班", hours: 0 }))
    }

    setAttendanceHourItems(AttendanceHourItems) {
        this.AttendanceHourItems = AttendanceHourItems
    }

    setAttendanceHour() {
        var hours = ""
        this.AttendanceHourItems.forEach((item, index, arr) => {
            if (index > 0) {
                hours += "/"
            }
            hours += item.hours
        })
        this.AttendanceHour = hours
    }

    //計算應付
    setSalary() {
        // console.log(this.PositionInfo)
        if (this.PositionInfo === undefined)
            return
        var PreTax = parseInt(this.PositionInfo.wageInfo.InvoiceHourlyWage1) * this.AttendanceHourItems[0].hours +
            parseInt(this.PositionInfo.wageInfo.InvoiceHourlyWage2) * this.AttendanceHourItems[1].hours +
            parseInt(this.PositionInfo.wageInfo.InvoiceHourlyWage3) * this.AttendanceHourItems[2].hours +
            parseInt(this.PositionInfo.wageInfo.InvoiceHourlyWage4) * this.AttendanceHourItems[3].hours +
            this.SalaryAddAmount - this.SalarySubtractAmount - this.AbsenceAmout
        this.PreTax = PreTax

        this.ExtraPayeHourlyWage = parseInt(this.PositionInfo.wageInfo.ExtraPayeHourlyWage) * this.AttendanceHourItems[0].hours 

        var Salary = parseInt(this.PositionInfo.wageInfo.PayHourlyWage1) * this.AttendanceHourItems[0].hours +
            parseInt(this.PositionInfo.wageInfo.PayHourlyWage2) * this.AttendanceHourItems[1].hours +
            parseInt(this.PositionInfo.wageInfo.PayHourlyWage3) * this.AttendanceHourItems[2].hours +
            parseInt(this.PositionInfo.wageInfo.PayHourlyWage4) * this.AttendanceHourItems[3].hours +
            this.SalaryAddAmount - this.SalarySubtractAmount - this.AbsenceAmout
        this.Salary = Salary

        this.PreServiceFee = PreTax - Salary - this.ExtraPayeHourlyWage
    }

    setDailyWageHourly() {

        // console.log(this.AttendanceRatio)
        // console.log(this.BaseSalary)
        this.MonthlySalary = Math.round(this.BaseSalary * this.AttendanceRatio) //窴際月薪
        console.log(this.MonthlySalary)
        this.setSalary()
    }
}

//出勤工時項目
export class ReqAttendanceHourItem {
    constructor({ key, name, hours = 0 }) {
        this.key = key
        this.name = name
        this.hours = hours
    }
    fromJson(jsonData) {
        this.key = jsonData.key
        this.name = jsonData.name
        this.hours = jsonData.hours
    }
    setHours(hours) {
        this.hours = hours
    }
}